import { CSSProperties } from 'react';
import { Badge } from 'components/common';
import { useReduxState } from 'hooks';

interface Props {
  style?: CSSProperties;
  type: 'event-ended' | 'guests-only-course' | 'unpublished-course';
}

const PathStepItemWarning = ({ style, type }: Props) => {
  const { messages } = useReduxState();

  const message = {
    'event-ended': messages.pathsEventEndedWarning,
    'guests-only-course': messages.coursesGuestsOnlyWarning,
    'unpublished-course': messages.pathsCoursesUnpublishedWarning
  }[type];

  return (
    <Badge
      category="warning-light"
      icon="exclamation-triangle"
      size="small"
      style={{
        height: 20,
        width: 20,
        paddingLeft: 5,
        paddingTop: 1,
        position: 'relative',
        ...style
      }}
      tooltip={message}
    />
  );
};

export default PathStepItemWarning;
